import { CanDeactivateFn } from '@angular/router';

import { of } from 'rxjs';

import { BarEditPageConsumer } from './bar-edit-page-consumer.contract';
import { BarEditPageSaveArgs } from './bar-edit-page-save-args.model';
import { BarEditPageSaveReason } from './bar-edit-page-save-reason.enum';

export function barEditPageCanDeactivateGuard(): CanDeactivateFn<BarEditPageConsumer> {
    return (component: BarEditPageConsumer) => {
        return component.requestSave ? component.requestSave({ reason: BarEditPageSaveReason.Autosave } as BarEditPageSaveArgs<any>) : of(true);
    };
}
